import React from 'react';
import { Pagination, Form } from 'react-bootstrap';
import { FORECAST_PAGE_SIZE_OPTIONS } from '../utils/dashboardConstants';

/**
 * Pagination serveur de forecast.items (GET /dashboard/operations/today).
 */
const ForecastListPagination = ({
    page = 1,
    totalPages = 0,
    total = 0,
    skip = 0,
    limit = 50,
    pageSize,
    onPageChange,
    onPageSizeChange,
    disabled = false,
}) => {
    if (!total || totalPages < 1) return null;

    const currentPage = Math.max(1, page);
    const from = skip + 1;
    const to = Math.min(skip + limit, total);

    return (
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 px-3 py-2 border-top">
            <div className="text-muted small">
                {from}–{to} sur {total} polic{total > 1 ? 'ies' : 'y'}
                {totalPages > 0 && (
                    <span className="ms-2">
                        · Page {currentPage} / {totalPages}
                    </span>
                )}
            </div>
            <div className="d-flex flex-wrap align-items-center gap-3">
                {onPageSizeChange && (
                    <Form.Group className="d-flex align-items-center gap-2 mb-0">
                        <Form.Label className="mb-0 text-muted small text-nowrap">Par page</Form.Label>
                        <Form.Select
                            size="sm"
                            style={{ width: 'auto' }}
                            value={pageSize ?? limit}
                            disabled={disabled}
                            onChange={(e) => onPageSizeChange(Number(e.target.value))}
                            aria-label="Taille de page forecast"
                        >
                            {FORECAST_PAGE_SIZE_OPTIONS.map((size) => (
                                <option key={size} value={size}>{size}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                )}
                <Pagination className="mb-0" size="sm">
                    <Pagination.Prev
                        disabled={disabled || currentPage <= 1}
                        onClick={() => onPageChange?.(currentPage - 1)}
                    />
                    <Pagination.Item active>{currentPage}</Pagination.Item>
                    <Pagination.Next
                        disabled={disabled || currentPage >= totalPages}
                        onClick={() => onPageChange?.(currentPage + 1)}
                    />
                </Pagination>
            </div>
        </div>
    );
};

export default ForecastListPagination;
